// File: frontend/src/components/marketing/ThemeToggle.js
//
// Public-site theme toggle. Uses the app's SINGLE colour-mode state
// (useColorMode from App) — it does NOT create a second theme system. Visible on
// every breakpoint with a >=40px touch target and a dynamic aria-label.

import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import DarkModeIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeIcon from "@mui/icons-material/LightModeOutlined";
import { useColorMode } from "../../App";

export default function ThemeToggle({ size = 40 }) {
  const { mode, toggleMode } = useColorMode();
  const isDark = mode === "dark";
  const label = isDark ? "Switch to light mode" : "Switch to dark mode";

  return (
    <Tooltip title={label}>
      <IconButton
        onClick={toggleMode}
        aria-label={label}
        sx={{
          width: size, height: size,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
          color: "text.secondary",
          "&:hover": { borderColor: "primary.main", color: "primary.main" },
          "&:focus-visible": { outline: (t) => `2px solid ${t.palette.primary.main}`, outlineOffset: 2 },
          transition: "all 0.2s",
        }}
      >
        {isDark
          ? <LightModeIcon sx={{ fontSize: 20, color: "warning.main" }} />
          : <DarkModeIcon sx={{ fontSize: 20 }} />}
      </IconButton>
    </Tooltip>
  );
}
